module.exports = __webpack_public_path__ + "static/media/rslogo.d43ed292.png";